export default __webpack_public_path__ + "static/media/Easy_To_Customize.77b4709b.svg";